const legalContents = {
  'legalTitle': `利用規約`,
  'privacy': {
    'tabName': `個人情報`,
    'header': `個人情報の取り扱いについて`,
    'description': `本個人情報取扱に関する方針では、本方針が掲示されたウェブサイトとアプリケーションで提供されたり、収集される情報の処理について説明します。
Bitfinder, Inc.（以下、「本社」とする。）は、利用者の個人情報を重視し、個人情報取扱に関する方針を通じて本社が利用者から提供を受けた個人情報をどのような用途と方式で利用しており、個人情報保護のため、いかなる措置を取っているのか示すものです。
本方針は2015年12月15日から実施され、これを改正する場合、ウェブサイトの告知事項(又は書面、電子メール等の個別公示)を通じて公示します。

1.収集する情報及び収集方法
(1)収集する個人情報の項目
本社が収集する個人情報の項目は、次の通りです。
ー
・メールアドレス
・性別
・生年月日
・位置情報
・ログ情報
・機器情報
本社は利用者が直接提供する情報と、利用者が本社のサービスを使用する過程で生成された情報を収集します。

(2)収集方法
本社は利用者の情報をアプリケーションのアカウント生成過程を通じて収集します。

2.収集した情報の利用
本社は、収集した利用者の情報を次のような目的のもと利用します。
・Awairアカウント管理、本人確認など
・許可されていないサービス利用と不正利用などの検知及び防止
・利用者が要求するサービスの提供に関する契約の履行、料金精算など
・既存サービスの改善や新規サービス開発など
・本社のウェブサイトまたはアプリケーションの機能またはポリシー変更事項のお知らせ
・会員のサービス利用に対する統計、統計学的特性に応じたサービス提供
・準拠法または法的義務の順守
本個人情報取扱に関する方針に明示された目的や他用途で情報を利用する場合、本社は利用者の同意を求めます。

3.収集した情報の共有
本社は次の場合を除いて利用者の個人情報を第三者に共有しません。
・法律上必要な場合
・法令上公開するよう要求される場合
・捜査目的として法令が定められた手続きと方法によって、捜査機関の要求がある場合
 4.個人情報の保有及び利用期間
本社は利用者の個人情報の収集及び利用目的が達成された場合、個人情報に対する法的もしくは経営的な必要性が解消された場合、または利用者が要請する場合、利用者の個人情報を滞りなく破棄します。ただし係る法令の規定により保存する必要がある場合、本社は、係る法令で定めた一定期間会員情報を保管します。

5.個人情報の破棄の手続きおよび破棄方法
本社は原則的に個人情報収集及び利用目的が達成された後には、該当する情報を滞りなく破棄します。 ただ、係る法令によって保管しなければならない情報は法令が定めた期間保管した後に破棄します。 この時、別途に保存管理される個人情報は、法令に定める場合でなければ、他の用途で利用されることはありません。 個人情報が含まれた紙での記録は破砕または焼却して、電子ファイルに保存された個人情報は技術的に復元が不可能な方法を利用して削除します。

6.利用者のアクセス権限と選択権
利用者または法廷代理人は、情報の主体として本社の個人情報の収集、使用、共有と関連し、次のような選択権を行使することができます。
・個人情報へのアクセス権限
・個人情報の訂正又は削除
・個人情報に対する処理の一時停止
・過去に提供した同意の撤回の要請
これらのために、アプリケーション内の「会員情報修正」メニューを利用したり、代表電話または本社の担当部署に書面、電話または電子メールで連絡をすることで滞りなく処置します。 ただし、本社は法律に明示された妥当な理由またはそれに相応する事由がある場合にのみ、そのような要請を拒否することができます。

7.個人情報保護のための技術的、管理的、物理的措置
本社は利用者の個人情報に対するセキュリティを非常に重要に考えています。本社は利用者個人情報の無断アクセス、公開、使用及び修正を防ぐため、次のようなセキュリティ措置を構築しています。
・個人情報の暗号化
・ハッキングなどに備えた対策
・内部管理計画の樹立・実施
・アクセス統制装置の設置及び運営
・アクセス記録の偽造、変造防止に向けた措置
・個人情報保護責任者指摘
・個人情報取扱者に対する教育
・個人情報処理システムに対するアクセス権限の差別化
・個人情報保管施設に対する出入り統制の手続きの樹立及び運営

8.個人情報取扱に関する方針の変更
本社は本方針を随時改変もしくは変更する権利を有します。本社が本方針を変更する場合、ウェブサイトの告知事項(又は書面、電子メール等の個別公示)を通じて公示して、係る法で要求する場合には、利用者の同意を求めます。

9.本社担当部署
本社は、利用者の個人情報を保護し、個人情報と関連する問い合わせ事項について下記のように関連部署を指定しています。 本方針についての問い合わせ事項や、、本社が保有している利用者の情報をアップデートしようとする場合、下記の連絡先まで本社にご連絡下さい。
・担当部署: 戦略運営
・Eメール: san@bitfinder.co
・個人情報管理責任者: San Baek 

最終更新日2018年8月`
  },
  'terms': {
    'tabName': `利用規約`,
    'header': `Awair サービス利用約款`,
    'description': `最終アップデート : 2/1/2016
Bitfinder, Inc.(以下、「本社」とする)は、消費者向け家電製品であるAwair(以下、「製品」とする)を製造し、販売しており、法人向けソリューションを提供する。また、本社は、次のようなサービスを提供するが、未来においてはこれらに限定されない。 :(1)www.getawair.comで接続できるウェブサイト(以下、「ウェブサイト」とする)、(2)スマートフォンとタブレットでダウンロード可能で、アップデート可能なソフトウェア(以下「モバイルアプリ」とする)、(3)アプリケーションプログラムインターフェイス(以下「API」とする)、(4)本社サービスの利用に係る分析、アドバイス、情報提供が可能な様々なコンテンツ(以下「コンテンツ」とする)、(5)、モバイルアプリにアクセスできる本社サービス利用者アカウント(以下「アカウント」とする)。「サービス」はサイト、モバイルアプリ、API、アカウントなど本社が提供する様々なサービスを全て含む用語とする。
この約款には法的効力を有する。サービスにアクセスしたり、利用することは利用者が(1)本社が提供するすべての約款に同意するものと見なす。 (2)この約款に同意する権利、権限、能力があることを保証する。 (3)法的管轄圏内で法的な契約を締結できる法律的な年であることを保証する。
1. 概要、資格、約款の終了 
2. 概要及び他の約款との関係 
この約款は利用者のサービス利用に適用される。サービスの特定機能は、該当する機能と関連して掲示された付加的なガイドライン、約款、規則の適用を受けることがある。すべての付加的なガイドライン、約款、規則(以下、「付加的約款」とする)は、この約款の参考として引用されており、サービスを利用するのは、該当する約款を遵守することに同意するものとみなされる。付加的約款は次を含む。
1. 本社の個人情報取扱に関する方針(以下、「個人情報取扱に関する方針」とする)は、利用者から収集される個人情報の利用と閲覧に関する本社のポリシーを含む。 
2. 製品の購買は本社の製品制限保証ポリシー(以下、「製品保証ポリシー」とする)の適用を受け、売買約款の適用を受ける。 
 
iii.Awairパッケージに含まれている購買と関連するすべての付加的約款
1. リファーラルプログラムのようなプロモーションと関連するすべての規則、約款、ガイドライン 
2. その他本社が追加し提供するすべての付加的約款 
3. 資格 
利用者は本社と拘束力のある契約を締結することができる場合にのみサービスを利用することができる。また、本約款を含めて本約款が適用される地域、国家、世界の法律、規則、規制を遵守する場合にのみサービスを利用することができる。18歳未満の青少年は、サービスの利用を保護者との相談の上考慮する必要がある。本社が提供するサービスを利用することが禁止されたことがあるすべての利用者は、サービスを利用することができない。
 
1. 約款の終了 
この約款は利用者がサービスにアクセスしたり、サービスを利用する限り、及び約款が定めるところによって終了されない限り、引き続き有効である。 信義誠実の原則にそって利用者が約款に違反する行為をしたと考えられる場合、本社はいつでも(i)利用者がサービスにアクセスしたり、サービスを利用する権利を中止/終了させたり、(ii)利用者に関する約款の効力を終了させることができる。  
1. 利用者アカウント 
特定のサービスを利用するためには必ずアカウントを作る必要があり、利用者に関する情報を提供する必要があります。利用者は、次を保証することとする。 :(a)利用者が必ず入力する全ての情報が真実であり、正確であること;(b)利用者が該当情報の正確性を維持する意思があるということ;(c)利用者がサービスを利用することが、国内法や他の適用可能な法律あるいは規定に違反しないということ(例えば、エンバーゴ措置になっている国家に位置しないあるいは貿易の禁止対象に該当しないこと)。利用者のアカウントのログイン情報の秘密を保守することとアカウントを通して行われるすべての行為は全面的に利用者の責任とする。利用者はセキュリティとして強力な暗証番号(大文字と小文字、数字、記号の組み合わせ)を使用することに同意し、利用者の許諾なしには、アカウントを利用できないようパスワードを安全に保管することに同意する。また、利用者のアカウントやセキュリティと関連した非正常な利用内訳や非正常的なものと疑われる利用内訳が発見された時には、直ちに本社に知らせることに同意する。本社は利用者が上の要求事項を全うしなかったことにもとづいて発生する損害や被害に対する責任を負わない。
 
 
III.サービスに対するアクセス
1. アクセスと利用 
この約款の適用を受けて、本社は利用者に本社のサービスにアクセスして利用できる制限的、譲渡不可能な、非独占的、廃棄可能なライセンスを付与します。(サブライセンスに対する権利はこの限りではない。)
 
1. 自動ソフトウェアアップデート 
本社は必要に応じてパッチ、バグ修正、アップデート、アップグレード、修正、改善、パフォーマンスを向上させることができる。(以下、「アップデート」とする)該当するアップデートは、付加的な告知を提供したり、同意を受けず、自動的に設置されるものである。利用者はこの自動アップデートに同意するものとする。もし、当該アップデートを望まない場合、モバイルアプリの利用を中止して、デバイスよりアプリを削除することとする。利用していたアカウントを削除しない場合、アップデートを自動的に受け取ることとなる。利用者は、サービスと製品を利用するためにはアップデートをする必要があるということを知っており、本社が提供するアップデートを迅速に設置することに同意する。利用者の継続的なサービスと製品の利用は上記の約款に対する同意を意味する。
 
1. 禁止事項 
本約款を通じて利用者に付与された権利は次の禁止事項の制限を受ける。:(i)本社のサービスを販売、貸与、リース、流通、仲介したり、商業的に利用しない ;(ii)本社のサービスを修正、分解、複製したり、これを利用して派生的な商品を作らない;(iii)類似サービスや、本社の競争対象となるサービスを作るためにサービスにアクセスしない;(iv)以下に明示的に表記されていない以上、サービスのどんな部分も複製、再生産、流通、再配布、ダウンロード、展示、掲示、送信しない ;(v)コンピュータウイルスやワームのように何らかの形で本社のコンピューター、通信ネットワーク、モバイル機器やデータ、サービス、製品、製品ソフトウェア、システム、機器、財産に被害を与えるために故意に作られたソフトウェアをアップロード、送信、流通しない ;(vi)サービスに連結されたサーバやネットワークに承認されなかったアプローチを試行したり、干渉したり、破壊したり、該当するネットワークの禁止事項、ポリシー、手続きに違反しない;(vii)本社が提供するインタフェースでない別の方法でサービスにアクセスしない;(viii)サービスと連結されて表示されたり含まれる所有権に対する公示(著作権と商標権に対する公示を含む)を削除したり、それらを不明瞭に作ったり、変更しないこと。今後、すべてのサービスの発売、アップデート、機能の追加は以上の禁止事項の適用を受ける。
1. 個人情報取扱に関する方針 
本社の個人情報取扱に関する方針を参考とする。個人情報取扱に関する方針は、本社が製品とサービスの利用者から収集する情報についての取扱い方法について説明する。
1. セキュリティー 
本社は、個人情報のセキュリティと管理方法の透明性を大切にする。しかし、本社は認められていない第三者が本社のセキュリティ措置をすり抜けたり不適切な目的で利用者の個人情報を絶対利用しないだろうと保証することはできない。利用者は利用者の個人情報をこのような危険性を甘受した上で提供していることを承知していることとする。
1. 修整 
本社はいつでもサービスやサービスの一部分を告知のもとに、あるいは通知なく修正、停止、中止する権利を有する。利用者は本社がサービスやサービスの一部分に対する修正、停止、中止について利用者や第三者に対して責任を負わないことに同意していることとする。
1. 特定の海外諸国でのアクセス 
本社のウェブサイトは全世界でアクセス可能であるが、ウェブサイトで提供もしくはアクセスできる製品とサービスは一部の人や、国家において利用不可能である。もし利用者が本社が製品とサービスを提供している国家(以下、「利用可能国家」とする)以外の国でウェブサイトや製品にアクセスしたりするような行為は全面的に利用者の意志によるものであり、該当する国家に適用される法律を遵守することに対して責任を負う必要がある。利用者はウェブサイトが利用可能国家ではない地域国家にて利用できるようデザインされていないことや、一部機能が作動しないことなど、本社のサービスや製品が該当国家に適していないことを理解し、同意したこととします。法律によって許可される範囲内で、本社は利用可能国家ではない地域国家でウェブサイトにアクセスして利用することによって発生する被害・損害に対して責任を負わない。 いかなる場所でウェブサイトにアクセス及び利用したり、サービスを利用しても該当条項は適用される。
 
1. 本社のサービスの利用と制限に対する同意 
2. 本社サービス利用に対する意図 
本社のサービスは製品の制御と非時間中心的な情報のためにアクセス及び利用できるように作らている。サービスを最大限安定的に利用可能にする意思を持っているが、100%すべての時間において安定的で、利用可能に作られているわけではない。Wi-Fi、サービス提供者の運営時間、モバイルでのお知らせ、通信会社の都合などの本社が制御できない様々な原因によってサービスに散発的な中断とエラーが発生する可能性がある。利用者はこれらの制限を知っており、本社が現状況によって発生するサービスの中断や遅延に被害を責任を負わないことに同意していることと見なす。
 
1. 生命保護など重大な事案と関連したサービスの利用禁止 
利用者は本社の製品とサービスが、独立的であっても第三者製品とサービスと連結していても、それらに関係なく応急状況に対する反応を保証しないことを認めて同意したものと見なす。本社は第三者製品やサービスとの連動を含めて製品とサービスの利用が安全性を向上することを保証しません。利用者は本社の製品とサービスが独立的であっても、第三者製品とサービスと連結していても、それらに関係なく、応急状況に対する第三者モニタリングのお知らせシステムではないことを理解しているものとする。本社は室内の応急状況に対する権限を持たない。付加的に、本社の顧客サポートの連絡先は室内に存在するヒトに対する救急方法と見なされことはできず、救急サービスに対する代替財ではない。生命に脅威を与えるすべての非常事態は適切なサービスを通じて処理される必要がある。
1. 通知の信頼性 
利用者は、遠隔接続とモバイルの通知を含めたサービスが100%信頼することはできず、100%利用可能ではないという点を理解しているものとする。本社は利用者がいつも通知を受けるということを保証できず、また保証しない。利用者は生命保護など重大な目的において本社のサービスに依存しないことに同意する。状況に関するモバイルの通知と本社製品に付随する通知は、情報伝達目的のためにのみ提供され、応急状況に対する第三者モニタリングの通知システムではない。本社が提供する非常状況に対する情報は安全に関する権威ある出典によるものであるが、本社は室内やそれ以外での状況と関連した特定的な情報を絶対に提供しない。利用者は非常状況においての行動や教育に関して状況に合わせて適切に行動することが利用者の責任であることに同意する。
1. 一時的中断 
サービスは、セキュリティ上の理由や、システム中断、維持補修などの原因によって通知なく一時的に中断されことがある。利用者は、該当する停止による補償を受けられないことに同意する。本社はサービスの稼動時間に対する保障を提供しない。  
1. システム要求事項 
サービスへのアクセスは、当該サービスに表示されている必要なシステム要求事項を持った利用者に限られる。特定のサービスは次の要求事項を備えていなければアクセスすることができない。(i)製品や信頼性を備えた通信ができるよう設置された室内で作動している無線Wi-Fiネットワーク;(ii)Awairアカウント;(iii)サービスがサポートされているスマートフォンやタブレットなどモバイルクライアント(特定機能によって要求される);(iv)室内で常に作動しているブロードバンドインターネット連結;(v)本社が提示するその他システム的要求事項。すべての必要なシステムの要素を備えて該当要素が互いに互換され適切に設定することは利用者の責任とする。利用者はシステム要求事項がサービスとの互換性が満たされなければ本社側より説明されたとおりの動作が不可能であることを理解していると見なす。付加的に、利用者はサービスの円滑な動作、Awairアカウントと連結された本社の製品との通信、その他の特定機能のために本社が事前に通知したり、通知せずにスマートフォンやタブレットのBluetoothをアクティベートできることを理解している。
 
1. 空気の質、健康、その他の効用 
「保証」を明示的に約束しない以上、本社はサービスで提供されるガイドに従うことを含めて本社の製品やサービスあるいは機能を利用することによる空気の清浄さや他の健康と関連した効用を保証したり、約束しない。 実際の空気の質は本社の制御できたり、保有している知識の外の要因によって異なる。時により、本社はサービスを利用して利用者や利用者の環境に合わせて個人化された情報を提供することができ、習慣を代替したり、改善できる方法を提供していく。この理由としては本社が測定して収集した情報とその分析に照らしあわせて利用者にとって実現可能なオプションを強調するためとする。利用者はこの提案が医療的助言でないことを理解し、効果と適用可能性が状況によって異なる可能性があることを知っていることとする。本社は、法律が許容する範囲内で、サービスを通じて提供される情報に基づいた利用者の行動に責任を負わず、該当する情報やガイドの適用可能性について保証したり、約束しない。提供される情報とガイドから発生するすべての健康と関連した質問は特定の医療機関にて行われなければならない。
1. 製品情報 
サービスは時により第三者製品、本社によって提供される連動製品あるいはサービスに対する情報(以下、「製品情報」とする)を利用者に提供することができる。 すべての製品情報は修正を加えられずに提供される。本社は該当する情報が正確であるか、最新であるかを保証しない。重要な場合において、サービスを通して、製品情報にアクセスすることは一般利用状況から製品情報に直接アクセスすることを代替できない。
1. コンテンツへのアクセス 
利用者はサービスを利用しながら、利用者がアクセスするすべてのコンテンツに対する危険を利用者が甘受し、それによって発生するすべての損害と被害に対する全面的な責任があることを理解していることと見なす。本社は利用者がコンテンツをどう解釈して利用し、それによってどんな行動をとるかについて、いかなる行動も取る義務を負わない。利用者はサービスを通じて得られるコンテンツと関連した本社に対する責任を問わないことに同意しているものと見なす。
 
1. 第三者による本社サービスの制限 
2. 一般 
特定状況において、本社のサービスは、第三者の製品やサービスに依存したり連動して運営されることがある。こうした第三者の製品とサービスは本社のコントール範囲外にあるが、本社のサービスの利用や信頼性に影響を及ぼす可能性がある。利用者は、次を理解して同意する :(i)サービスの利用と利用可能性は第三者の製品の販売者とサービス提供者に依存的であること (ii)この第三者の製品とサービスは必ずしも常に運営されていない可能性があり、この事実が本社のサービス運営に影響を与えかねないこと (iii)本社は第三者の製品とサービスの運営によって生じる損害と被害に対して責任を負わないこと
1. 本社が利用する第三者サービス提供者 
利用者は本社がサービスの特定の側面を可能にするため、第三者サービス提供者を利用するということを理解する。利用者は時間が絶対的に重要な事案や生命に関わる安全に関する事案においてサービスに依存しないことに同意する。
1. 設備、インターネットサービス供給者、通信会社 
利用者はサービスの利用の可能性が(i)利用者のパソコンやモバイル機器、家のインターネットの接続、無線Wi-Fiネットワーク、Bluetooth接続、そして他の連結された装備(以下「装備」とする)、(ii)インターネットサービス供給者、(iii)利用者のモバイル機器、通信社(以下「通信会社」とする)に依存的という事実を理解している。 利用者は、サービスの利用につながるインターネットサービス供給者や通信会社によって請求される全ての料金に対する責任があるということを理解している。 また、利用者はインターネットサービス供給者と通信会社の全ての適用可能な合意、約款、ポリシーを遵守する責任があるということを理解している。
1. 本社サービスと共に作動する第三者の製品とサービス 
本社は、本社モバイルアプリやAPIなどを通じて利用者に第三者の製品やサービスを制御、連動、アクセスできるチャンスを提供することができます。モバイルアプリと本社APIが本社により提供されている事実に関係なく、利用者は利用者のアカウントを連結させる第三者の製品とサービスが本社の製品とサービスでないことを理解し、本社がそのような製品とサービスを制御できず、本約款が適用されないことを理解する。すべての第三者の製品とサービスの利用は、当該運営者が提供する独立的な約款によって規律されている。利用者は第三者の製品やサービスを利用するに当たって、本社がそれらに関する安全を保障しないことを理解し、同意する。また、本社は第三者の製品やサービスを利用者が利用したことに起因して発生しかねない負傷、死亡、住宅を含めた財産損害、あるいはどのような被害に対しても責任を負わない。第三者の製品とサービスに関連する問い合わせは、該当する第三者に連絡する必要がある。
 
1. アプリストア 
利用者は、モバイルアプリの利用可能性がモバイルアプリをダウンロードする第三者のアプリストア(以下「アプリストア」とはApple社が提供するApp Store及びGoogle社が提供するアンドロイドアプリマーケットの総称とする)に依存的であることを理解して同意する。利用者は本約款が本社と利用者の間の約款であり、アプリストアとの約款でないということを理解する。各アプリストアは、アプリをインストールするために同意する必要のある独自の約款を有している。利用者は、当該約款を遵守することに同意し、モバイルアプリをダウンロードできるライセンスは、該当する同意によって得ることができる。アプリストアの約款が本約款より厳しくなかったり、内容が衝突する事案については本約款が優先される。
1. 第三者のウェブサイトリンク、情報、推薦 
本社のウェブサイトは第三者が運営する別のウェブサイト(以下「第三者のウェブサイト」とする)と第三者の情報供給会社(以下「第三者供給会社」とする）の紹介に対するリンクが含められている可能性がある。該当する第三者のウェブサイトや第三者供給会社は本社の制御下にない。本社は、リンクや紹介文章などを一種の説得材料として提供し、該当する第三者のウェブサイトや第三者供給会社を検討、同意、推薦、保証するものではない。このような第三者のウェブサイトを利用するリスクは利用者が甘受する。
1. 第三者と関連したリスク 
本社はアプリストア、第三者の製品とサービス、第三者のウェブサイト、第三者供給会社、設備、インターネットサービス提供者、通信会社のような第三者や第三者の製品とサービスに一切の責任を負わない。本社と利用者は第三者と第三者の製品とサービスとの接触に際して発生しうる、すでに周知及び未だ周知されていない過去・現在・未来の請求、責任、損害に対して本社、本社のライセンサー、供給者に対してのみ救済処置を取る。利用者はCALIFORNIA CIVIL CODE SECTION 1542を放棄する。 CALIFORNIA CIVIL CODE SECTION 1542とは、「一般的な救済は創作者が知らなかったり救済した時に創作者の利益に存在するものと推定される、周知されていたものであれば、債務者との合意に物質的に影響を及ぼしたことが明らかな請求に拡大されない。」というものである。利用者は他の管轄圏でも類似の規定を放棄する。
1. 所有権と知的財産権 
2. 本社の財産 
利用者は、製品やサービス(例:ウェブサイト、モバイルアプリ、APIなど)のすべての著作権、特許、商標、営業秘密を含む知的財産権が本社、提携会社、ライセンス保有者の所有であることを理解しているものと見なす。利用者の製品、製品、ソフトウェアやサービスに対する占有、アクセス、利用は利用者や第三者に一切の権利、タイトル、利益を移転させない。本社、提携会社、ライセンス保有者、供給者は、本約款に規定されていないすべての権利を享有する。サービスは本約款の下で利用者に販売されるものではなく、ライセンスが付与されるものとして理解する。
 
1. 利用制限 
利用者は本ウェブサイトを含めるサービスの一部を複製して利用者のコンピューターに個人的な用途でのみ保存することができる。利用者はサービスのコンテンツを公共及び商業的な方法で利用してはならず、利用者のウェブサイトを含めて他の作業物に本社の書面同意なしにコピーしたり併合してはならない。利用者はサービスの一部分を掲示したり再配布する前に本社より係るライセンス等を取得する必要がある。本社はサービスのダウンロード可能なソフトウェアとそれらと同伴するデータを含む全てのコンテンツに対して完全な保有権を維持します。利用者はサービスやサービスのコンテンツの表現や構成を再生産したり、故意に被害を与える方式で複製したり、修正してはならない。
1. フィードバック 
利用者は本社が要請したり、あるいは自ら製品やサービスに対する改善策を含めた意見について、提案、アイディア（以下、「フィードバック」とする）を提出することができます。フィードバックを提出することにより、利用者は該当の提出が自発的であり、無償で、無制限適任に同意し、本社を受託者の地位に置いたり、どのような義務も与えないことに同意する。 本社は提出されたフィードバックに対する補償を提供せず、どのような方式で、どのような目的であれ利用して、修正し、複製して、出版して、再配布することができる。利用者はまた、本社がすでに持っていた、従業員によって作られたり、他の出所を通じて得た、似ていたり、関連するフィードバックに対する権利を放棄することに同意する。
VII.保証
1. 保証 
利用者は利用者の(i)製品やサービスの利用、(ii)本約款に対する違反、(iii)フィードバックや問い合わせ、(iv)法律や第三者の権利に対する違反によって第三者に生じる損害、責任、紛争、弁護士選任費用を含む請求に対して本社とライセンス保有者、供給者の利益を保護することを保証、また防御することに同意する。本社は利用者の費用で排他的な防御と本社を保証するためにとるべき措置を取れる権利を保有し、利用者は当該紛争に対する防御に協力することに同意する。利用者は本社の事前書面での同意なしにはどのような紛争も終結させることができない。本社がこのような紛争、措置、進行状況について知った際に、これを利用者に知らせるための合理的な努力を惜しまない。
 
VIII.保証否認
1. 製品に対する保証は制限保証である。 
2. サービス(ウェブサイト、モバイルアプリ、APIなど)は利用者の便宜のために一切の編集などを加えずにそのままの状態で提供され、本社、ライセンス保有者、供給者は明示的にどのような種類の保証もしない。保証は明示的な保証と暗黙的な保証をすべて含み、特定の目的に対する適合性、特定の目的への適合性、正確性、および遵守を含める。 
3. 本社、ライセンス保有者、供給者は(I)利用者の要求事項を満たすことができるように;(II)室内のネットワーク、コンピュータ、モバイル機器と互換できるように;(III)途切れることなく、適時に、安全に、エラー無しに利用できるように;(IV)正確で信頼を持つことができるように欠陥を修正するという保証をしない。口頭もしくは書面に関わらず、本社が利用者から得た助言や情報は一切の保証義務を持たない。 
4. 本社は本社の製品とサービスと連結され、第三者が広告したり、連動したり、提供する製品やサービス(本社モバイルアプリを通じてつながる第三者製品とサービスを含めるが、これに限らない)、ハイパーリンクされているウェブサイトやサービスについて保証、保障、推薦したり、責任を負わない。また、本社は利用者と第三提供者間の当該製品やサービスに対する取引の一方となったり、どのような方式であれ監視体制を持たない。 
5. 本社が提供する製品やサービスを設置、セットアップ、利用する時に利用者は基本設定を変えたり、特定の設定を選択できる機会があります。 利用者の選択は連結された装備やシステムに損害を発生させたり、該当装置やシステムを推奨されていない方式で作動させてしまうことに繋がる可能性がある。利用者が特定の設定を選択したり、基本設定を変えたことに起因して発生する損害に対するすべての責任を本社は負わない。 
6. 本社はサービスを通じてアクセスできたり、含まれているコンテンツに対する保証をしない。本社はサービスを通じてアクセスできたり、含まれているコンテンツの精度、著作権遵守事項、法的効力、道徳性に対する責任を負わない。本社はサービスを通じて提供されたり、購買されたサービスと製品の推薦と提案を保証しない。 
7. 責任の限界 
8. 本約款のすべての条項と、特にこの「責任の限界」部分の条項は適用可能な法律によって除外することができない全ての責任を除外しようと試行しない。 
9. 適用可能な法律によって許可される最大範囲内で、上記の保証否認に加えて,いかなる場合でも(A)本社は、サービスや製品と関連して発生する利益の喪失とデータの喪失による被害を含めた間接、結果、一般、特別、付随的被害に対する責任を負わず(B)サービスと製品と関連していたり、これを通して発生した本社の総累積責任は利用者が本社や本社の公認代理店に問題になるサービスや製品にの対価として12ヵ月内に支払った費用を超過しない。 この制限は、累積的であり、一つ以上の事件や紛争の存在により増加することはない。本社は本社のライセンス保持者と供給者の全ての責任を否認する。どのような状況下においても、本社は、誤記や省略を含め、これらに限定されない全てのコンテンツや、メールで発送したり、アクセスされたり、送信されたり、掲示されたり、その他のサービスを通じて利用可能になったコンテンツに対する露出や利用と関連して発生する全ての損害や被害について責任を負わない。 
10. 料金と決済 
11. 特定サービスは有料で提供される。利用者は規定された販売約款によって選択したサービスに該当する料金を支払う必要がある。 
12. 紛争と仲裁 
13. 利用者は本社まで先に連絡することに同意する。 
もし利用者と本社の間に紛争が発生した際には、本社の目標は利用者の不満に対して学習し、理解していくことであるため、利用者は本約款、製品、サービスに関して発生する本社とのすべての紛争について先に本社に連絡して知らせることに同意したものと見なす。
 
1. 装備、インターネットサービス提供者、通信会社 
利用者と本社は秘密の保障と知的財産権条項に照らして、本約款とサービスの利用によって発生したり、これと関連するすべての請求、紛争、行動、行動の原因、争点、救済要請に対して、ここに明示された法廷を除いた法廷に訴訟を提起する前に拘束力のある仲裁機関に提出することに同意したものと見なす。また、利用者は仲裁が裁判所によって非常に制限的な再検討だけが可能な最終的なもので、拘束力があるということに同意する。また、利用者は放棄が有効に行われる限り、すべての形の嘆願、再検討、償還請求をすべての裁判所や他の司法当局に提出する権利を放棄する。この条項は利用者のサービス利用と関連したりこれによって発生するすべての紛争と請求を含むよう広く解釈される意図を持っている。本約款の秘密保障と知的財産権条項に照らして、本約款と関連したりこれによって発生している利用者と本社の間のすべての紛争と請求は小口請求裁判所で処理できる事案でない限り、拘束力のある仲裁により解決される。
1. 仲裁手続き 
利用者は先にすべての請求と紛争について本社に連絡して提起し、本社に解決する機会を提供する必要がある。利用者は万一本社に提起した後、60日以内に請求や紛争が解決されなければ、仲裁を要請することができる。本社は本約款の通知の部分に応じて利用者に請求や紛争について開示した後、いかなる時にでも仲裁を要請することができる。すべての紛争や請求の仲裁は本協議により調整された、当時の適用可能なAmerican Arbitration Associationの規則によって進められる。すべての仲裁の場所は、米国のカリフォルニア州パロアルト市になり、英語で行われる。請求は単一仲裁者を通じて解決される。仲裁者は本協議が提供する内容を超過したり反対する救済、集団や代理に対する仲裁、命令を結合することができず、一方の実際の損害のほかに懲罰的であったり、結果的な損害を判決することはできず、仲裁者が法令によって個人の損害について判決したり、適用可能な消費者保護法令により禁止命令の救済や宣言的判決を行える状況を除いては禁止命令の救済や宣言的判決ができない。すべての仲裁は機密事項であり、利用者と本社、仲裁者は法律による要請、仲裁判決に対する控訴、強制履行の目的がない限り仲裁判決の存在、内容、結果について公開することはできない。仲裁判決に対する判断は適切な管轄権は裁判所に属する可能性がある。万一、本仲裁条項の一部が裁判所によって適用不可能だったり、有効ではないと判断されても、残りの部分は引き続き有効である。
 
1. 集団訴訟の禁止 
本仲裁条項の対象である請求権は、集団訴訟若しくは連結に基づいて、又は一般弁護士(弁護士を含むが,これに限定されない。)に代わって代理権として主張される請求権を含む基礎に基づいて仲裁されるものではない.
1. 料金及び費用 
仲裁のすべての行政料金と費用は利用者と本社が同等に配分することとする。各当事者は仲裁手続きでそれぞれの相談、専門家、目撃者、証拠の準備と提示による費用を負担する。
利用者は必ず本社との紛争を発生させる事実や事件の発生日から1年以内に本社に連絡する必要がある。そうしない場合に当該事件、事実、紛争に対して請求できる権利を失うこととする。
 
XII.一般
1. 約款の変更 
本社は本約款を変更する権利を保有する。本社は本ページに約款の修正に対する公示を掲載するものとする。利用者はサービスを利用する際に最新の約款を読んで同意したことを確認する必要がある。約款の変更に対する告知以降のサービスの継続的な利用は利用者が該当する約款の変更を理解しており、修正された約款に同意していることを意味する。
1. 準拠法 
一部の国の裁判所は、一部の種類の紛争にカリフォルニア法律を適用しない。利用者がそのような国家に住んでいる場合、当該国家の法律が適用される。そうでないなら場合、利用者はこの約款とこの約款や製品とサービス利用により発生する請求、紛争、行為、行為の原因、争点、救済要請が衝突する他の管轄権の法律ではなくカリフォルニア州法によって取り上げられることに同意する。利用者は請求や紛争が上とのように仲裁される必要がいない限り、全ての訴訟を個人管轄権とカリフォルニア州サンタクララ・カウンティの連邦裁判所に提起することに同意する。
1. 秘密保障と知的財産権 
上記に関わらず、本社は秘密情報と知的財産権を保護し、サーバーのデータに対する被害を防止するために競争的管轄権の禁止命令またはその他公正な救済策を探すこととする。
1. 同意の全体性及び分離性 
本約款はサービス利用に関する利用者と本社の間の同意の全体を構成します。 本社のこの条項による権利や条項の執行や強制の失敗は、当該権利や条項の放棄と見なされない。本約款のセクションのタイトルは便宜によるものであり、法的あるいは、契約的効力を持たない。万一、本約款のいかなる条項がどのような理由であれ、有効でない、強制できなくなると、本約款の他の条項は損傷せず、有効でなかったり、強制できない条項は法律によって許容される最大限に有効で、強制できるように修正されたものと見なさられる。両当事者は相手のパートナーや代理人ではない。
 
1. 存続性 
所有権条項、保証否認、責任の制限を含めて本合意のすべての条項は終了後にも当然有効に存続されなければならず、有効に存続する。
1. 譲渡 
本約款、またすべての係る権利と義務は本社の事前書面同意なしには利用者は譲渡できない。本約款は本社によりのみ譲渡される。 本約款はすべての許可された譲受人に拘束力を持つ。
1. 通知 
本社は、法によって必要な場合やマーケティングをするための目的でアカウントに連結された電子メール、モバイルの通知、書面、ウェブサイトの掲示を通じて通知を提供することができる。本社は利用者のネットワーク提供者や利用者が設定するEメールフィルタリングに起因する一切の責任を負わない。本社は本社が送る通知メールを確実に受けられるように@getawair.comを受け取れるよう電子メールを設定することを推奨する。
1. 公開 
カリフォルニアの居住者はクレームなどをthe Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairsに送ることができる。400 R Street、Sacramento、CA 95814へ郵便物を送るか、もしくは+1 (800)952-5210に電話をすることができる。
1. 著作権及び商標権情報 
Copyright©2015、Bitfinder Inc.All rights reserved.サービスに表示されたすべての商標、ロゴ、サービスマーク(以下「マーク」とする)らは本社の財産であったり、それぞれの所有者の財産である。利用者は本社や、当該所有者の書面同意なくどのようなマークも利用することができない。本社は製品やサービスの提供内容、スペック、価格を通知なくいつでも変更できる権利を有し、この文書や関連文書にありうるタイプミスやグラフィックの誤りに対して責任を負わない。
`
  },
  'warranty': {
    'tabName': `保証`,
    'header': `Awair製品の保証ポリシー`,
    'description': `Awair（以下「製品」とする）を使用することにより、購入者はBitfinder（以下「本社）とする）が提供する以下の保証規約に同意することになります。もし保証規約に同意しない場合、最初の購入日から7日以内に未使用かつ購入時の状態で製品を返品する必要があります。この場合、以下の顧客満足度保障ポリシーの返品手順に従うことになります。
 
【顧客満足度保障ポリシー】
製品の最終使用者である購入者が商品を購入した後、いかなる理由であっても製品に不満を感じた場合には、最初の購入日から7日以内に製品を購入した時の状態のまま返送することで購入金額分の返金を受けることができます。購入日から7日が過ぎていないことを証明することができる製品の領収書や購入履歴内容を添付して、カスタマーセンターまでメールをお送りください。配送員が購入者宅に訪問して製品を回収します（返送費は購入者が負担）。サービスセンターは回収された製品の使用有無を確認した後、異常がない場合は購入者に領収書に記載されている金額を返金します。製品が購入時の状態のまま返品されていないと判断された場合には、製品を購入者に返送し、書面でその根拠について説明します。


【保証期間と保証範囲]
当社は、製品の最終使用者である購入者が製品を最初に購入した日から1年間、使用中に発生した部品や製造上の欠陥を保証します。ただし、以下の場合には保証は適用されません。
（a）部品や製造上の欠陥による故障ではない、時間の経過に応じて発生する消耗
（b）傷、凹み、プラスチックの破損などを含むが、これらに限定されず最初の購入日以後の部品および製造上の欠陥によらない、外見上の欠陥
（c）欠陥のある他の製品を一緒に使用して発生した損傷
（d）誤用、乱用、事故、火災、地震、洪水、台風またはその他外部の原因による損傷
（e）当社が公開するガイドラインに反する方法で製品を作動させて発生した損傷
（f）当社に属さない者が行なったサービスに起因する損傷
（g）当社の書面による許可なしに機能や性能を変更するために改造した製品
（h）正常的な消耗や破損、またはその他の製品の通常の老化に起因する欠陥
（i）盗難や、当社が法執行機関が提供する情報に基づいて盗難にあったと見なすことができる合理的な理由がある製品
（j）当社が認める公式販売店でないその他の販売店から購入された製品
(k) 木材部分は木が自然的に持っている色、カラートーン、柄によって違う外形を持つ可能性があります。本社はディスプレイやサンプルと実際に受け取る製品との間で木材の特性によって生じる自然的な差(色、光具合、紫外線による変色など）がないことを保証しません。ディスプレイやサンプルは、あくまでも例としての目的に使用されるため、購入する製品と全く同じであることは保障できません。ディスプレイやサンプルとの違いに基づいて提起される保証の要請は受け付けていません。

 
【無償保証サービス]
当社は、製品の最終使用者である購入者が製品を最初に購入した日から1年間、通常の使用中に発生した部品や製造上の欠陥を保証します。（以下「保証期間」とする）、保証期間内に以下の手順を経て、当社に返送された機器に故障があると判断される場合には、製品の修理もしくは新品ないし整備済製品への交換を承ります。あるいは購入者が希望する場合、購入金額を返金します。当社に返送された製品のうち、保証期間外および保証範囲外の場合、有償保証サービスの利用要否を購入者に確認し、これを希望されない場合には往復配送費を受領した後、購入者に返送します。

*無償保証サービス進行手順
カスタマーセンター（hello@getawair.com/メール/電話）にて解決できない場合、カスタマーセンターの担当者がサービスセンターへ修理サービスのリクエスト・受付⇒配送員が購入者宅を訪問し、製品および領収書をサービスセンターへ送付（着払い）⇒無償保証サービスの範囲内外を判断（無償サービス範囲外であると判断されると、有償保証サービスの進行手順に従う）⇒修理完了製品もしくは完備済製品を購入者に発送、あるいは購入者が希望する場合は返金します。
 
【有償保証サービス]
無償保証期間が過ぎた製品、または、無償保証期間内に購入者の過失や故意により製品の不良や欠陥が発生した場合、修理または交換サービスは有償で提供します。また、領収書を紛失したり提示しない場合にも、修理や交換サービスは有償で提供します。すべての有償サービスは、公式の受付を介してのみ行われ、往復配送料は購入者の負担となります。各サービスの費用は、当社の方針に応じて変更される可能性があります。

*有償保証サービス進行手順
カスタマーセンター（hello@getawair.com /メール/電話）で解決出来ない場合、カスタマーセンターの担当者がサービスセンターへ修理サービスのリクエスト・受付⇒配送員が購入者宅を訪問し、製品および領収書をサービスセンターへ送付（着払い）⇒購入者が有償修理および交換を希望する場合は、サービスセンターで製品の修理または部品の交換作業⇒往復配送料を含む修理サービス費用の受領確認後、修理完了製品もしくは完備済製品を購入者に発送します。
`
  }
};

export default legalContents;


// WEBPACK FOOTER //
// ./src/assets/contents/legal.js